// extracted by mini-css-extract-plugin
export default {"inputs-wrapper":"trf-settings_inputs-wrapper__yOrZH","checkbox":"trf-settings_checkbox__8b3MP","page-spinner":"trf-settings_page-spinner__a-RzW"};